module.exports = __webpack_public_path__ + "img/dots.svg?c493192ed92b0dbea58953249f5f6c2b";